// services/authService.js
import axiosInstance from "./axiosInstance";

// Đăng ký
export const registerUser = async (userData) => {
    const res = await axiosInstance.post("/auth/register", userData);
    return res.data;
};

// Đăng nhập
export const loginUser = async (credentials) => {
    const res = await axiosInstance.post("/auth/login", credentials);
    return res.data;
};

// Đăng xuất
export const logoutUser = async () => {
    const res = await axiosInstance.post("/auth/logout");
    return res.data;
};

// Quên mật khẩu
export const forgotPassword = async (email) => {
    const res = await axiosInstance.post("/auth/forgot-password", { email });
    return res.data;
};

// Đặt lại mật khẩu
export const resetPassword = async (token, password) => {
    const res = await axiosInstance.post(`/auth/reset-password?token=${token}`, { password });
    return res.data;
};